import React, { useEffect, useState } from 'react';
import { CButton, CCard, CHeader, CRow, CCol, CImage, CContainer } from '@coreui/react';
import Moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { getTransactionListById } from 'src/services/Transactions';
import formatter from 'src/reusables/formatter';
import ls from 'local-storage';
import { Typography } from '@mui/material';
import { Toaster } from 'src/components/Toaster';

const PHOTO_RESULT_BASE_URL = 'memories.sukhakala.id/?id='

function TransactionDetails() {
    const [refetch, setRefetch] = useState(false);
    const [renderCounter, setRenderCounter] = useState(0);
    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState("")

    const endDay = Moment(new Date()).format('YYYY-MM-DD');
    const max = new Date(endDay);
    const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');
    const [trx, setTrx] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    async function fetchTransactionById(id) {
        const res = await getTransactionListById(id);
        setTrx(res.data[0]);
    }

    useEffect(() => {
        if ((refetch && renderCounter > 0) || renderCounter === 0) {
            fetchTransactionById(ls.get("state").trxId);
            setRefetch(false);
        }

        setRenderCounter(renderCounter + 1);
    }, [refetch]);

    return (
        <>
            <Toaster
                open={open}
                message={message}
                setOpen={setOpen}
                ahd={1500}
            />
            <div style={{ color: 'black' }}>
                <CCol>
                    <CButton
                        className="ml-3 mb-3 btn btn-dark"
                        style={{ backgroundColor: '#4E5B97', border: 'none' }}
                        hover="true"
                        onClick={() => {
                            ls.remove("state")
                            navigate('/transaction-list');
                        }}
                    >
                        Back
                    </CButton>
                </CCol>
                <CRow>
                    <CHeader style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw' }}>Transaction Detail: </CHeader>
                </CRow>
                <CCard style={{ textAlign: 'left', padding: '2vh 3vw' }}>
                    <CCol xs="12">
                        <CRow>
                            <CCol>ID</CCol>
                            <CCol>{trx?.id}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Paid At</CCol>
                            <CCol>{trx?.paidAt ? formatter('completeDate', trx?.paidAt) : '-'}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Done At</CCol>
                            <CCol>{trx?.doneAt ? formatter('completeDate', trx?.doneAt) : '-'}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Duration</CCol>
                            <CCol>{trx?.duration ?? '0'} Minutes</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Price</CCol>
                            <CCol>{formatter('currency', trx?.price ?? 0)}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Discount</CCol>
                            <CCol>{formatter('currency', trx?.discount ?? 0)}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Grand Total</CCol>
                            <CCol>{formatter('currency', trx?.grand_total ?? 0)}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Voucher Code</CCol>
                            <CCol>{trx?.voucherCode}</CCol>
                        </CRow>

                        <CRow>
                            <CCol>Frame</CCol>
                            <CCol>{trx?.frameName ?? '-'}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Timeout</CCol>
                            <CCol>{trx?.timeout === 1 ? 'Yes' : 'No'}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Happy Hour</CCol>
                            <CCol>{trx?.is_happy_hour === 1 || trx?.is_happy_hour === "1" ? 'Yes' : 'No'}</CCol>
                        </CRow>
                        <CRow>
                            <CCol>Image</CCol>
                            <CCol>
                                {
                                    trx?.imageURL ?
                                        (trx?.imageURL?.includes('Failed To Upload') ? (
                                            <p>{trx?.imageURL}</p>
                                        ) : (
                                            <CImage width="300vh" src={trx?.imageURL ?? ''} />
                                        )) :
                                        '-'
                                }
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>Photo Result</CCol>
                            <CCol>
                                <CContainer
                                    onClick={(e) => {
                                        navigator.clipboard.writeText(e.target.innerText)
                                        setMessage('Link copied!')
                                        setOpen(true)
                                    }}
                                >
                                    {`${PHOTO_RESULT_BASE_URL}${trx?.uuid}`}
                                </CContainer>
                            </CCol>
                        </CRow>
                    </CCol>
                </CCard>
            </div>
        </>
    );
}

export default TransactionDetails;
